import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import {
  Heading,
  PrimaryButton,
  SecondaryButton,
  Text,
  useForm,
} from '@weave/design-system';

import { HandoffMetrics } from './handoff-metrics/handoff-metrics';
import { HandoffSnapshot } from '../../../handoff-hub.types';
import { getHandoffTypeConstData } from './handoff-metrics/handoff-metrics-helpers';
import { useDependentMetricData } from './handoff-metrics/use-dependent-metric-data';

type Props = {
  handoffNameInitialValue: string;
  handoffTypeData: ReturnType<typeof getHandoffTypeConstData>;
  dependentData: ReturnType<typeof useDependentMetricData>;
  onNextClick: (updates: Partial<HandoffSnapshot>) => void;
  onSaveAndClose: (updates: Partial<HandoffSnapshot>) => void;
  onCancelClick: () => void;
};

export const HandoffSnapshotMetrics = ({
  handoffNameInitialValue,
  handoffTypeData,
  dependentData,
  onNextClick,
  onSaveAndClose,
  onCancelClick,
}: Props) => {
  const { formProps, isComplete, values } = useForm({
    fields: {
      handoffName: {
        type: 'text',
        required: false,
        value: handoffNameInitialValue,
      },
    },
  });

  const getHandoffData = () => ({
    handoffName: values.handoffName,
  });

  const disabledButtons = !isComplete;

  return (
    <form {...formProps}>
      <>
        {/* hiding this for now because they asked for it to be removed but could return later */}
        {/*<div css={handoffNameContainer}>*/}
        {/*  <Text weight="bold">Enter Handoff Name</Text>*/}
        {/*  <TextField*/}
        {/*    label={handoffTypesDisplayValuesMap[handoffType]}*/}
        {/*    {...getFieldProps('handoffName')}*/}
        {/*    css={inputStyle}*/}
        {/*  />*/}
        {/*</div>*/}

        <HandoffMetrics handoffTypeData={handoffTypeData} dependentData={dependentData} />
      </>
      <div css={buttonBar}>
        <SecondaryButton css={cancelButton} onClick={onCancelClick}>
          Cancel
        </SecondaryButton>

        <SecondaryButton
          css={saveButton}
          onClick={() => onSaveAndClose(getHandoffData())}
          disabled={disabledButtons}
        >
          Save and Close
        </SecondaryButton>

        <PrimaryButton
          css={nextButton}
          onClick={() => onNextClick(getHandoffData())}
          disabled={disabledButtons}
        >
          Next
        </PrimaryButton>
      </div>
    </form>
  );
};

const buttonBar = css`
  display: flex;
  justify-content: flex-end;
`;

const cancelButton = css`
  max-width: 150px;
`;

const saveButton = css`
  max-width: 200px;
  margin-right: ${theme.spacing(1)};
  margin: ${theme.spacing(0, 1)};
`;

const nextButton = css`
  max-width: 100px;
`;

const textStyles = css`
  margin: ${theme.spacing(2, 0, 0, 0)};
`;
